<template lang="pug">
    .progress-steps-bar
        yan-progress(:total="100" :done="done" :modify="modify" :tip=`
            [
                {
                    text: "",
                    fillStyle: "#F0F2F6",
                }, {
                    text: "",
                    fillStyle: "rgba(255, 0, 0, 0.15)",
                }, {
                    text: "",
                    fillStyle: "#FF0000"
                }
            ]
            `)
</template>

<script>

    export default {
        name: 'ProgressBar',
        data() {
            return {
                done: 10,
                modify: 5
            }
        },
        watch: {
            $route (to) {
                // booking process
                if(to.path == '/') {
                    this.done = 10;
                    this.modify = 5;
                }

                if(to.name == 'event') {
                    this.done = 20;
                    this.modify = 10;
                }

                if(to.name == 'conference') {
                    this.done = 30;
                    this.modify = 20;
                }
                
                if(to.name == 'accommodation') {
                    this.done = 40;
                    this.modify = 30;
                } 
                
                if(to.name == 'accommodation') {
                    this.done = 50;
                    this.modify = 40;
                }
                
                if(to.path == '/meal') {
                    this.done = 60;
                    this.modify = 50;
                } 
                
                if(to.path == '/activities') {
                    this.done = 70;
                    this.modify = 60;
                }
                
                if(to.path == '/confirmation') {
                    this.done = 80;
                    this.modify = 70;
                }
                
                if(to.path == '/checkout') {
                    this.done = 90;
                    this.modify = 80;
                }
                
                if(to.path == '/result') {
                    this.done = 100;
                    this.modify = 100;
                }
                
                // create event process
                if(to.path == '/new-event') {
                    this.done = 20;
                    this.modify = 10;
                }

                if(to.path == '/new-event-confirmation') {
                    this.done = 40;
                    this.modify = 30;
                }

                if(to.path == '/new-event-checkout') {
                    this.done = 70;
                    this.modify = 60;
                }
                
                if(to.path == '/event-result') {
                    this.done = 100;
                    this.modify = 100;
                }                
            }
        }
    };
</script>

<style lang="sass">
    .progress-steps-bar
        margin: 10px 0 0

        .y-progress
            height: 6px

            .y-progress_text
                .y-tooltip
                    border: 1px solid rgb(240, 242, 246)
                    border-radius: 0
                    background: #fff
                    color: #313648
                    text-transform: uppercase
                    font:
                        size: 10px

                    &::after
                        border-color: transparent transparent rgb(240, 242, 246) transparent
</style>


